import classNames from 'classnames';
import { bool, object, string } from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as validators from '../../util/validators';
import FieldCheckbox from '../FieldCheckbox/FieldCheckbox';
import FieldLocationInput from '../FieldLocationInput/FieldLocationInput';
import { Heading } from '../Heading/Heading';
import useInterfaceLang from '../../hooks/useInterfaceLang';

import css from './LocationDetails.module.css';

const LocationDetails = props => {
  const { language } = useInterfaceLang();

  const {
    className,
    rootClassName,
    headingClassName,
    intl,
    formId,
    values,
    excludeCheckbox = false,
  } = props;
  const classes = classNames(css.root || rootClassName, className);

  return (
    <div className={classes}>
      <Heading as="h3" rootClassName={classNames(css.heading, headingClassName)}>
        <FormattedMessage id="SignupForm.locationDetails" />
      </Heading>

      <FieldLocationInput
        intl={intl}
        formId={formId}
        name={formId ? `${formId}.businessAddress` : 'businessAddress'}
        labelId="SignupForm.businessAddress"
        validate={validators.composeValidators(
          validators.autocompleteSearchRequired(intl.formatMessage({ id: 'Global.required' })),
          validators.autocompleteHasLocationInfo(
            intl.formatMessage({ id: 'LocationInput.selectedPlaceRequired' })
          )
        )}
        types={['place']}
        language={language}
      />

      <FieldLocationInput
        fieldClassName={css.field}
        intl={intl}
        formId={formId}
        name={formId ? `${formId}.visitingAddress` : 'visitingAddress'}
        labelId="SignupForm.visitingAddress"
        placeholderId="SignupForm.visitingAddressPlaceholder"
        types={['place']}
        required={false}
        disabled={!excludeCheckbox && values.isAddressMatching}
        language={language}
      />

      {!excludeCheckbox && (
        <FieldCheckbox
          name="isAddressMatching"
          id={`${formId}.isAddressMatching`}
          label={intl.formatMessage({
            id: 'SignupForm.addressMatchingLabel',
          })}
          className={css.field}
        />
      )}
    </div>
  );
};

LocationDetails.propTypes = {
  className: string,
  rootClassName: string,
  headingClassName: string,
  intl: object.isRequired,
  formId: string.isRequired,
  values: object.isRequired,
  excludeCheckbox: bool,
};

export default LocationDetails;
